import { render, staticRenderFns } from "./RegisterCalendar.vue?vue&type=template&id=24dd4f5d&scoped=true"
import script from "./RegisterCalendar.vue?vue&type=script&lang=js"
export * from "./RegisterCalendar.vue?vue&type=script&lang=js"
import style0 from "./RegisterCalendar.vue?vue&type=style&index=0&id=24dd4f5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd4f5d",
  null
  
)

export default component.exports